<template>
  <a-modal
    title="新增点位"
    :visible="visibleModal"
    :confirm-loading="modalConfirmLoading"
    @ok="addPointsHandleOk"
    okText="保 存"
    cancelText="取 消"
    @cancel="addPointsHandleCancel"
    width="900px"
  >
    <CustomTransfer
      :transferTableLoading.sync="transferTableLoading"
      :data-source="allPointsList"
    ></CustomTransfer>
  </a-modal>
</template>

<script>
import api from "../../../commomFun/api.js";
import CustomTransfer from "../../common/customTransfer.vue";
export default {
  components: {
    CustomTransfer
  },
  props: {
    visibleModal: {
      type: Boolean,
      default: () => false
    },
    modalId: Number
  },
  data() {
    return {
      allPointsList: [],
      transferTableLoading: false,
      modalConfirmLoading: false
    };
  },
  created() {
    this.getTagAllPointList();
  },
  methods: {
    // 点位穿梭框数据
    getTagAllPointList() {
      if (!this.modalId) {
        this.$message.warning("获取标签ID失败！");
        return;
      }
      this.transferTableLoading = true;
      this.allPointsList = [];
      api
        .getApi(`/tag/getTagAllPointList`, { tagId: this.modalId })
        .then(res => {
          if (res.data.code == 200) {
            if (Array.isArray(res.data.data.list)) {
              let tempAllPointsList = res.data.data.list;
              this.allPointsList = tempAllPointsList;
            }
          } else {
            this.$message.warning(res.data.msg || "获取点位失败");
          }
        })
        .catch(e => {
          console.error("getTagAllPointListError", e);
        })
        .finally(() => {
          this.transferTableLoading = false;
        });
    },
    addPointsHandleOk() {
      if (!this.modalId) {
        this.$message.warning("获取标签ID失败！");
        return;
      }
      let targetKeys = this.allPointsList
        .filter(item => item.selectFlag)
        .map(item => item.id);
      if (targetKeys.length === 0) {
        this.$message.warning("已选点位为空！");
        return;
      }
      this.modalConfirmLoading = true;
      api
        .putApi(`/tag/point`, {
          tagId: this.modalId,
          pointIds: targetKeys
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$emit("update:visibleModal", false);
            this.$emit("reloadPointList");
            this.$message.success(res.data.msg || "新增点位成功！");
          } else {
            this.$message.warning(res.data.msg || "新增点位失败！");
          }
        })
        .catch(e => {
          console.error("addPointsHandleOk", e);
        })
        .finally(() => {
          this.modalConfirmLoading = false;
        });
    },
    addPointsHandleCancel() {
      this.$emit("update:visibleModal", false);
    }
  }
};
</script>

<style scoped lang="scss">
.export_step_box {
  border: 1px dashed rgba(218, 218, 218, 1);
  padding: 12px 18px;
  color: rgba(102, 102, 102, 1);
  font-size: 15px;
  position: relative;
  &:hover {
    cursor: pointer;
    border-color: #409eff;
  }
  img {
    margin-right: 8px;
    width: 26px;
    height: 26px;
    vertical-align: middle;
  }
  .downloag_btn {
    position: absolute;
    right: 18px;
    top: 50%;
    cursor: pointer;
    transform: translateY(-50%);
    color: rgba(102, 102, 102, 1);
  }
}

.upload_img {
  width: 26px;
  height: 26px;
}
</style>
